document.addEventListener('DOMContentLoaded', function () {
  // Delego il click per qualsiasi bundle presente nella pagina
  document.addEventListener('click', function (event) {
    const bundleButton = event.target.closest('button-submit-bundle');
    if (!bundleButton) return;

    event.preventDefault();

    const bundleBox = bundleButton.closest('.bundle-sticky');
    if (!bundleBox) return;

    // Trova tutti i prodotti selezionati nel bundle
    const items = [];
    const products = bundleBox.querySelectorAll('[data-product-bundle-variant][data-variant-id]');

    products.forEach(function (prod) {
      const id = prod.getAttribute('data-variant-id');
      if (!id) return;

      const qtyInput = prod.querySelector('.quantity__input');
      let qty = 1;
      if (qtyInput) {
        const parsed = parseInt(qtyInput.value, 10);
        if (!isNaN(parsed) && parsed > 0) qty = parsed;
      }

      items.push({
        id: Number(id),
        quantity: qty
      });
    });

    if (!items.length) {
      console.warn('Nessun prodotto selezionato nel bundle.');
      return;
    }

    // Aggiunge tutti gli articoli al carrello in un colpo solo
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Errore risposta /cart/add.js');
        return res.json();
      })
      .then(function () {
        // Prova ad aprire il cart drawer se esiste
        const cartDrawer = document.querySelector('cart-drawer');

        // Alcuni temi hanno un metodo .open(), altri usano eventi
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // fallback brutale ma efficace
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('Errore aggiunta bundle al carrello:', err);
        // fallback in caso di disastro
        window.location.href = '/cart';
      });
  });
});
